import { css } from "@emotion/core"
import styled from "@emotion/styled"
import React from "react"
import Button from "../Button/button"

import { mq } from "../mixins"

import "./richText.scss"

const RichText = props => {
  const RichTextContainer = styled("div")`
    max-width: 100%;
    margin: 0 auto;
    ${props.full_width !== true &&
      `
    ${mq("smTablet")} {
      max-width: 770px;
    }`}
  `

  const richTextHeadline = css`
    padding: 0;
    margin: 0;
    text-align: left;
    color: #fff;
    &.light {
      color: #000;
    }
    ${mq("smTablet")} {
      ${props.full_width !== true && 'text-align: center;'}
    }
  `

  const richTextBody = css`
    color: #fff;
    &.light {
      color: #000;
    }
    ${mq("smTablet")} {
      ${props.full_width !== true && 'text-align: center;'}
    }
  `

  return (
    <div className="richText">
      <RichTextContainer
        className={`richText__container container ${props.color_theme}`}
      >
        {props.headline && (
          <div className="richText__header">
            {props.full_width === true ? (
              <h4
                css={richTextHeadline}
                className={`
            headline 
            ${props.color_theme}
            ${
              props.rich_text_editor.includes("text-align: center;")
                ? "center"
                : ""
            }`}
              >
                {props.headline}
              </h4>
            ) : (
              <h2
                css={richTextHeadline}
                className={`
          headline 
          ${props.color_theme}
          ${
            props.rich_text_editor.includes("text-align: center;")
              ? "center"
              : ""
          }`}
              >
                {props.headline}
              </h2>
            )}
          </div>
        )}
        <div
          css={richTextBody}
          className={`richText__body ${props.color_theme}`}
          dangerouslySetInnerHTML={{ __html: props.rich_text_editor }}
        ></div>
        {props.button.length !== 0 && (
          <div className="button__container">
            {props.button.map((data, index) => {
              return (
                <Button
                  key={index}
                  button_link={data.button_link.href}
                  button_link_type={data.button_link_type}
                  button_text={data.button_text}
                  button_color={data.button_color}
                  button_type={data.button_type}
                  text_color={data.text_color}
                />
              )
            })}
          </div>
        )}
      </RichTextContainer>
    </div>
  )
}

export default RichText
